$(function() {
    // Validation

    if ($('#contact-form').length > 0) {
        $('#contact-form').validate({
            ignore: [],
            rules: {
                contact_name: {
                    required: true
                },
                contact_email: {
                    required: true,
                    email: true
                },
                contact_telephone: {
                    required: true,
                    number: true
                },
                contact_text: {
                    required: true
                },
                contact_privacy: {
                    required: true
                }
            },
            messages: {
                contact_name: {
                    required: window.validationMessages['name.required']
                },
                contact_email: {
                    required: window.validationMessages['email.required'],
                    email: window.validationMessages['email.email']
                },
                contact_telephone: {
                    required: window.validationMessages['phone.required'],
                    number: window.validationMessages['phone.number']
                },
                contact_text: {
                    required: window.validationMessages['text.required']
                },
                contact_privacy: {
                    required: window.validationMessages['terms.accepted']
                }
            },
            highlight: function(element) {
                $(element).parent().addClass('group-error');
            },
            unhighlight: function(element) {
                $(element).parent().removeClass('group-error');
            }
        });
    }

    if ($('#colocation-contact-form').length > 0) {
        $.validator.addMethod('valueNotEquals', function(value, element, arg) {
            return arg !== value;
        }, window.validationMessages['option.required']);

        $('#colocation-contact-form').validate({
            ignore: [],
            rules: {
                name: {
                    required: true
                },
                email: {
                    required: true,
                    email: true
                },
                phone_number: {
                    required: true,
                    number: true
                },
                unit: {
                    required: true,
                    valueNotEquals: 'default'
                },
                power_consumption: {
                    required: true
                },
                connectivity: {
                    required: true,
                    valueNotEquals: 'default'
                },
                open_text: {
                    required: true
                },
                contact_privacy: {
                    required: true
                },
            },
            messages: {
                name: {
                    required: window.validationMessages['name.required']
                },
                email: {
                    required: window.validationMessages['email.required'],
                    email: window.validationMessages['email.email']
                },
                phone_number: {
                    required: window.validationMessages['phone.required'],
                    number: window.validationMessages['phone.number']
                },
                unit: {
                    required: window.validationMessages['units.required']
                },
                power_consumption: {
                    required: window.validationMessages['consumption.required']
                },
                connectivity: {
                    required: window.validationMessages['connectivity.required']
                },
                open_text: {
                    required: window.validationMessages['text.required']
                },
                contact_privacy: {
                    required: window.validationMessages['terms.accepted']
                }
            },
            highlight: function(element) {
                $(element).parent().addClass('group-error');
            },
            unhighlight: function(element) {
                $(element).parent().removeClass('group-error');
            }
        });
    }

    if ($('#apply-form').length > 0) {
        $.validator.addMethod('filesize', function(value, element, param) {
            return this.optional(element) || (element.files[0].size <= param)
        }, window.validationMessages['file.filesize']);

        $('#apply-form').validate({
            ignore: [],
            rules: {
                apply_name: {
                    required: true
                },
                apply_email: {
                    required: true,
                    email: true
                },
                apply_telephone: {
                    required: true,
                    number: true
                },
                apply_text: {
                    required: true
                },
                apply_privacy: {
                    required: true
                },
                cv_file: {
                    required: true,
                    filesize: (8 * Math.pow(10, 6) * 4) // Should be in bits
                },
                other_file: {
                    filesize: (8 * Math.pow(10, 6) * 4) // Should be in bits
                }
            },
            messages: {
                apply_name: {
                    required: window.validationMessages['name.required']
                },
                apply_email: {
                    required: window.validationMessages['email.required'],
                    email: window.validationMessages['email.email']
                },
                apply_telephone: {
                    required: window.validationMessages['phone.required'],
                    number: window.validationMessages['phone.number']
                },
                apply_text: {
                    required: window.validationMessages['text.required']
                },
                apply_privacy: {
                    required: window.validationMessages['terms.accepted']
                },
                cv_file: {
                    required: window.validationMessages['cv.required'],
                    filesize: window.validationMessages['file.filesize_4mb']
                },
                other_file: {
                    filesize: window.validationMessages['file.filesize_4mb']
                }
            },
            highlight: function(element) {
                $(element).parent().addClass('group-error');
            },
            unhighlight: function(element) {
                $(element).parent().removeClass('group-error');
            }
        });
    }

    // File upload

    $('input[type=file]').on('change', function() {
        var text = $(this).val();
        text = text.substring(text.lastIndexOf("\\") + 1, text.length);

        if ($(this).closest('.upload-cv-container').length > 0 && $('#upload-cv').valid()) {
            $('.uploaded-files .upload-cv').html('').append('<i class="icon icon-uncheck"></i>' + text);
        }

        if ($(this).closest('.upload-other-container').length > 0 && $('#upload-other').valid()) {
            $('.uploaded-files .upload-other').html('').append('<i class="icon icon-uncheck"></i>' + text);
        }
    });

    $('.uploaded-files a').on('click', function(e) {
        e.preventDefault();

        var file = $(this).attr('class');

        $(this).text('');
        $('#' + file).val(null);
    });
});